document.addEventListener('DOMContentLoaded', function () {
    let button = document.getElementById('try-again');
    let progressBar = document.getElementById('progress-bar');

    if (button && progressBar) {
        let timeRemaining = 60; // 60 seconds
        let interval = setInterval(updateButton, 1000);

        function updateButton() {
            timeRemaining--;

            // Calculate width of the progress bar based on remaining time
            let width = (timeRemaining / 60) * 100;
            progressBar.style.width = width + '%';

            // make the button clickable
            if (timeRemaining <= 0) {
                clearInterval(interval);
                button.disabled = false;
                button.style.cursor = 'pointer';
                progressBar.style.display = 'none';
            }
        }

        button.addEventListener('click', function() {
            location.reload();
        });
    }
});
